import { LitElement, html } from 'lit-element';
import { connect } from '../core/connect';

export class NextUpcomingOrder extends LitElement {
  static get properties() {
    return {
      upcomingOrderDate: {
        type: String,
        attribute: false
      }
    };
  }

  render() {
    return html`
      ${this.upcomingOrderDate}
    `;
  }
}

export const mapStateToProps = state => ({
  upcomingOrderDate: state.previewUpsellOffer ? new Date().toDateString() : state.nextUpcomingOrder.place
});

export const ConnectedNextUpcomingOrder = connect(mapStateToProps)(NextUpcomingOrder);

export default NextUpcomingOrder;
